module.exports = __webpack_public_path__ + "img/logo2.4a9c56af.png";